/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import BoxV1 from "components/Atoms/Box/BoxV1";
import InputDefault from "components/InputFields/InputDefault";
import Checkbox from "@mui/material/Checkbox";
import Box from "components/Atoms/Box";
import TypographyV1 from "components/Atoms/Typography/TypographyV1";
import InputPassword from "components/InputFields/InputPassword";

function Credentials({ setCredentials, credentials }) {
  const { t } = useTranslation(["auth"]);

  const onChangeAgreement = () =>
    setCredentials({ ...credentials, agreement: !credentials.agreement });
  const onChangeName = (e) => setCredentials({ ...credentials, name: e.target.value });
  const onChangeEmail = (e) => setCredentials({ ...credentials, email: e.target.value });
  const onChangePassword = (e) => setCredentials({ ...credentials, password: e.target.value });

  return (
    <BoxV1>
      <InputDefault
        label={t("signup.fields.name")}
        onChange={onChangeName}
        placeholder={t("signup.fields.name")}
        mt={2}
        mb={2}
      />
      <InputDefault
        label={t("signup.fields.email")}
        type="email"
        onChange={onChangeEmail}
        placeholder={t("signup.fields.email")}
        mt={2}
        mb={2}
      />
      <InputPassword
        label={t("signup.fields.password")}
        onChange={onChangePassword}
        mt={2}
        mb={2}
      />

      <Box mt={3} textAlign="start">
        <Checkbox checked={credentials.agreement} onChange={onChangeAgreement} />
        <TypographyV1 variant="button" textColor="text" fontWeight="regular">
          {t("signup.agreement_prefix")}
          <TypographyV1
            component={Link}
            to="/terms-and-conditions"
            variant="button"
            fontWeight="medium"
          >
            {" "}
            {t("signup.agreement_terms")}
          </TypographyV1>
        </TypographyV1>
      </Box>
    </BoxV1>
  );
}

Credentials.defaultProps = {};

Credentials.propTypes = {
  setCredentials: PropTypes.func.isRequired,
  credentials: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    agreement: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Credentials;
